import { render } from "./ItemsDrawer.vue?vue&type=template&id=6cb42daf&scoped=true"
import script from "./ItemsDrawer.vue?vue&type=script&lang=js"
export * from "./ItemsDrawer.vue?vue&type=script&lang=js"

import "./ItemsDrawer.vue?vue&type=style&index=0&id=6cb42daf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb42daf"]])

export default __exports__